import { Palette, Zap, HeartHandshake } from "lucide-react";
import { MaskedLine, FadeUp } from "@/components/Reveal";
import { useLanguage } from "@/i18n/LanguageContext";

const CHAPTER_ICONS = { "01": Palette, "02": Zap, "03": HeartHandshake };

export const Manifesto = () => {
  const { t } = useLanguage();
  const chapters = ["01", "02", "03"].map((no) => ({
    no,
    icon: CHAPTER_ICONS[no],
    title: t(`manifesto.${Number(no)}.title`),
    text: t(`manifesto.${Number(no)}.text`),
  }));

  return (
  <section id="services" data-testid="manifesto-section" className="mx-auto max-w-7xl px-6 py-32 md:px-12 md:py-48">
    <span className="text-sm uppercase tracking-[0.3em] text-[#FF3333]">{t("manifesto.label")}</span>
    <h2 className="mt-4 font-syne font-extrabold uppercase tracking-tighter text-[#F2F2F2]">
      <MaskedLine innerClassName="text-4xl sm:text-5xl lg:text-6xl">{t("manifesto.heading")}</MaskedLine>
    </h2>

    <div className="mt-24">
      {chapters.map((ch, i) => {
        const Icon = ch.icon;
        return (
          <FadeUp key={ch.no} delay={i * 0.08}>
            <div
              data-testid={`manifesto-chapter-${ch.no}`}
              className={`group grid grid-cols-1 gap-8 border-t border-[#262626] py-16 transition-colors duration-500 hover:border-[#FF3333]/40 md:grid-cols-[auto_1fr_1.2fr] md:items-center md:gap-16 ${
                i % 2 === 1 ? "md:pl-24" : ""
              }`}
            >
              <span className="font-syne text-7xl font-extrabold leading-none tracking-tighter text-stroke transition-colors duration-500 group-hover:text-[#FF3333] md:text-9xl">
                {ch.no}
              </span>
              <div>
                <Icon className="mb-4 h-8 w-8 text-[#FF3333]" />
                <h3 className="font-syne text-2xl font-bold tracking-tight text-[#F2F2F2] md:text-3xl">
                  {ch.title}
                </h3>
              </div>
              <p className="max-w-xl text-base leading-relaxed text-[#A3A3A3] md:text-lg">{ch.text}</p>
            </div>
          </FadeUp>
        );
      })}
    </div>
  </section>
  );
};
